import React from 'react';

interface ErrorIconProps {
  className?: string;
  size?: number;
}

const ErrorIcon: React.FC<ErrorIconProps> = ({ className = '', size = 18 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9.00008 13.1665C9.23619 13.1665 9.43411 13.0866 9.59383 12.9269C9.75355 12.7672 9.83342 12.5693 9.83342 12.3332C9.83342 12.0971 9.75355 11.8991 9.59383 11.7394C9.43411 11.5797 9.23619 11.4998 9.00008 11.4998C8.76397 11.4998 8.56605 11.5797 8.40633 11.7394C8.24661 11.8991 8.16675 12.0971 8.16675 12.3332C8.16675 12.5693 8.24661 12.7672 8.40633 12.9269C8.56605 13.0866 8.76397 13.1665 9.00008 13.1665ZM8.16675 9.83317H9.83342V4.83317H8.16675V9.83317ZM9.00008 17.3332C7.8473 17.3332 6.76397 17.1144 5.75008 16.6769C4.73619 16.2394 3.85425 15.6457 3.10425 14.8957C2.35425 14.1457 1.7605 13.2637 1.323 12.2498C0.885498 11.2359 0.666748 10.1526 0.666748 8.99984C0.666748 7.84706 0.885498 6.76373 1.323 5.74984C1.7605 4.73595 2.35425 3.854 3.10425 3.104C3.85425 2.354 4.73619 1.76025 5.75008 1.32275C6.76397 0.885254 7.8473 0.666504 9.00008 0.666504C10.1529 0.666504 11.2362 0.885254 12.2501 1.32275C13.264 1.76025 14.1459 2.354 14.8959 3.104C15.6459 3.854 16.2397 4.73595 16.6772 5.74984C17.1147 6.76373 17.3334 7.84706 17.3334 8.99984C17.3334 10.1526 17.1147 11.2359 16.6772 12.2498C16.2397 13.2637 15.6459 14.1457 14.8959 14.8957C14.1459 15.6457 13.264 16.2394 12.2501 16.6769C11.2362 17.1144 10.1529 17.3332 9.00008 17.3332Z"
        fill="#F74545"
      />
    </svg>
  );
};

export default ErrorIcon;
